export function useQuery(key) {
  const searhParams = new URLSearchParams(window.location.search);
  if (key) return searhParams.get(key);
  return Object.fromEntries(searhParams);
}
